import { render } from "./EditPets.vue?vue&type=template&id=896ed2f4&scoped=true"
import script from "./EditPets.vue?vue&type=script&lang=js"
export * from "./EditPets.vue?vue&type=script&lang=js"

import "./EditPets.vue?vue&type=style&index=0&id=896ed2f4&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-896ed2f4"]])

export default __exports__